<template>
    <div v-if="show_contact_btn" id="body">
        <div class="chat-box">
            <div class="chat-box-header">
                {{ $t('Support Chat') }}
                <span class="chat-box-toggle">
                    <i class="fl-ico _close"></i>
                </span>
            </div>
            <div class="chat-box-body">
                <div class="chat-box-overlay">
                </div>
                <div class="chat-logs">
                    <div v-for="(message, index) in messages" :key="index" class="row message-body">
                        <div
                            :class="message.sender_type == 'Guest' ? 'col-sm-12 message-main-send' : 'col-sm-12 message-main-received'">
                            <div :class="message.sender_type == 'Guest' ? 'send' : 'received'">
                                <div class="message-text">
                                    <pre>{{ message.msg }}</pre>
                                </div>
                                <span class="message-time pull-right">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true" role="img" font-size="1rem" class="iconify iconify--mdi"
                                        width="1em" height="1em" viewBox="0 0 24 24">
                                        <path fill="currentColor"
                                            d="M.41 13.41L6 19l1.41-1.42L1.83 12m20.41-6.42L11.66 16.17L7.5 12l-1.43 1.41L11.66 19l12-12M18 7l-1.41-1.42l-6.35 6.35l1.42 1.41L18 7Z">
                                        </path>
                                    </svg>
                                    {{ new Date(message?.created_at).toLocaleTimeString('fr-FR', {
                                        hour:
                                            '2-digit', minute: '2-digit',
                                        hour12: true
                                    }) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--chat-log -->
            </div>
            <div class="chat-input">
                <input v-model="message" type="text" id="chat-input" :placeholder="$t('Send a message')"
                    autocomplete="off" />
                <div class="inline-block float-left chat-text ">
                    <button v-if="canSend" @click="sendMessage" class="btn btn-chat-send">
                        <i class="chat-btn btn-send"></i>
                    </button>
                    <button v-else class="btn btn-chat-send" :disabled="true">
                        <i class="chat-btn btn-send"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var that;
import $ from 'jquery';
import WhatsappMessageSent from '../assets/audio/WhatsappMessageSent.mp3';
import WhatsAppNewMessage from '../assets/audio/WhatsAppNewMessage.mp3';
import pusher from '../plugins/pusher';
import chatService from '@/services/saudi-cup/chat/chat-service';
export default {
    name: 'ChatButton',
    data() {
        return {
            show_contact_btn: false,
            messages: [],
            message: '',
            title: "Conversations",
            canSend: false,
            chat_open: false,
            chat_name: '',
            user_token: ''
        };
    },
    methods: {
        sendMessage() {
            var guest_data = JSON.parse(localStorage.getItem("guest_data"));
            this.chat_name = guest_data.guest.registration_number;
            this.messages.push({
                sender_type: 'Guest',
                msg: this.message,
                created_at: new Date()
            });
            const body = {
                sender_type: 'Guest',
                chat_name: this.chat_name,
                msg: this.message
            };
            this.message = '';
            this.canSend = false;
            $(".chat-logs").animate({
                scrollTop: 9999999
            }, 'slow');
            chatService.send_message(body).then((response) => {
                var audio = new Audio(WhatsappMessageSent);
                audio.play();
            }).catch(function (error) {
                if (error.response) {
                    console.error('Error sending audio:', error.response.data);
                }
            });
        },
        Jquery() {
            $(document).on('input', '#chat-input', function () {
                var val = $(this).val();
                if (val.length > 0) {
                    that.canSend = true;
                } else {
                    that.canSend = false;
                }
            });
            $(document).on('click', '#chat-circle', function () {
                that.chat_open = true;
                $(".chat-logs").animate({
                    scrollTop: 9999999
                }, 'slow');
                $("#chat-circle").toggle('scale');
                $(".chat-box").toggle('scale');
            })
            $(document).on('click', '.chat-box-toggle', function () {
                that.chat_open = false;
                $("#chat-circle").toggle('scale');
                $(".chat-box").toggle('scale');
            });
            $(document).on('keypress', function (e) {
                if (that.message != '' && $('#chat-input').is(":focus") && e.which == 13) {
                    that.sendMessage();
                }
            });
        },
    },
    mounted() {
        that = this;
        this.Jquery();
        setTimeout(() => {
            this.user_token = localStorage.getItem("user_token");
            if (this.user_token) {
                this.show_contact_btn = true;
                chatService.get_chat_messages().then((response) => {
                    this.messages = response.data.data?.messages ?? [];
                    $(".chat-logs").animate({
                        scrollTop: 9999999
                    }, 'slow');
                    const channel = pusher.subscribe('chat.' + this.chat_name);
                    channel.bind('Sent.' + this.chat_name, (data) => {
                        if (data.senderType == 'User') {
                            this.messages.push({
                                sender_type: data.senderType,
                                msg: data.message,
                                created_at: new Date()
                            });
                            $(".chat-logs").animate({
                                scrollTop: 9999999
                            }, 'slow');
                            if (that.chat_open == true) {
                                var audio = new Audio(WhatsAppNewMessage);;
                                audio.play();
                            }
                        }
                    });
                });
            }
        }, 500);
    }
}
</script>
<style lang="scss">
#chat-circle:hover{
    color: #000;
}
.fl-30-ico.chat {
    background-position: -120px -30px;
}

.fl-30-ico {
    background-image: url('~@/assets/icons/30x30.png');
    width: 26px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.float-left {
    float: left;
}

.chat-btn.btn-mic {
    background-position: -30px 0;
}

.chat-text button {
    color: #cb538d;
    background: #fff;
    box-shadow: none !important;
    outline: 0 !important;
    width: 35px;
    padding: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border:  none !important;
}
.chat-btn.btn-img {
    background-position: 0 0;
}

.chat-btn {
    display: inline-block;
    background-image: url('~@/assets/svg/chaticon.svg');
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    transition: .2s all ease-in-out;
}

#center-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

}
.btn#my-btn {
    background: white;
    padding-top: 13px;
    padding-bottom: 12px;
    border-radius: 45px;
    padding-right: 40px;
    padding-left: 40px;
    color: #5865C3;
}

#chat-overlay {
    background: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: none;
}

.chat-box-toggle {
    float: left;
    margin-left: 15px;
    cursor: pointer;
    position: relative;
    top: -10px;
}

.chat-box-header {
    background: #8154a1;
    height: 60px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    color: white;
    text-align: right;
    font-size: 20px;
    padding-top: 17px;
    padding-right: 20px;
}

.chat-box-body {
    position: relative;
    height: 370px;
    height: auto;
    overflow: hidden;
}

.chat-box-body:after {
    content: "";
    background-image: url('data:image/svg+xml;base64,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');
    opacity: 0.1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    position: absolute;
    z-index: -1;
}



.chat-input>form {
    margin-bottom: 0;
}

#chat-input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
}

#chat-input::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
}

#chat-input:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
}

#chat-input:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
}

.chat-submit {
    position: absolute;
    bottom: 3px;
    right: 10px;
    background: transparent;
    box-shadow: none;
    border: none;
    border-radius: 50%;
    color: #8154a1;
    width: 35px;
    height: 35px;
}

.chat-logs {
    padding: 15px 0px;
    height: 370px;
    overflow-y: auto;
}

.chat-logs::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
}

.chat-logs::-webkit-scrollbar {
    width: 5px;
    background-color: #F5F5F5;
}

.chat-logs::-webkit-scrollbar-thumb {
    background-color: #8154a1;
}

@media only screen and (max-width: 500px) {
    .chat-logs {
        height: 40vh;
    }
}

.chat-msg.user>.msg-avatar img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    float: left;
    width: 15%;
}

.chat-msg.self>.msg-avatar img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    float: right;
    width: 15%;
}

.cm-msg-text {
    background: white;
    padding: 10px 15px 10px 15px;
    color: #666;
    max-width: 75%;
    float: left;
    position: relative;
    margin-bottom: 20px;
    border-radius: 1.125rem 1.125rem 1.125rem 0;
}

.chat-msg {
    clear: both;
}

.chat-msg.self>.cm-msg-text {
    float: right;
    background: #8154a1;
    color: white;
    border-radius: 1.125rem 1.125rem 0 1.125rem;
}

.cm-msg-button>ul>li {
    list-style: none;
    float: left;
    width: 50%;
}

.cm-msg-button {
    clear: both;
    margin-bottom: 70px;
}

.message {
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    margin: 1rem;
    background: #FFF;
    border-radius: 1.125rem 1.125rem 1.125rem 0;
    min-height: 2.25rem;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 66%;
    box-shadow: 0 0 2rem rgba(0, 0, 0, 0.075), 0rem 1rem 1rem -1rem rgba(0, 0, 0, 0.1);
}

.message .typing.typing-1 {
    -webkit-animation: typing 3s infinite;
    animation: typing 3s infinite;
}

.message .typing {
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0rem;
    box-sizing: border-box;
    background: #ccc;
    border-radius: 50%;
}

@keyframes typing {

    0%,
    75%,
    100% {
        transform: translate(0, 0.25rem) scale(0.9);
        opacity: 0.5;
    }

    25% {
        transform: translate(0, -0.25rem) scale(1);
        opacity: 1;
    }
}

.message {
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    margin: 1rem;
    background: #FFF;
    border-radius: 1.125rem 1.125rem 1.125rem 0;
    min-height: 2.25rem;
    width: fit-content;
    max-width: 66%;
    position: absolute;
    left: 0;

    .typing {
        display: inline-block;
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0rem;
        box-sizing: border-box;
        background: #ccc;
        border-radius: 50%;

        &.typing-1 {
            animation: typing 3s infinite
        }

        &.typing-2 {
            animation: typing 3s 250ms infinite
        }

        &.typing-3 {
            animation: typing 3s 500ms infinite
        }
    }
}

.fl-ico._close {
    background-position: -161px -23px;
    opacity: 1 !important;
}

.fl-ico {
    background-image: url('~@/assets/icons/23x23.svg');
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    width: 23px;
    height: 23px;
    position: relative;
    margin: 0 5px;
}

.chat-text {
    padding: 10px;
}

.file-container {
    display: none;
    background-color: #f0f2f5;
    padding: 20px 20px;
    border-bottom: 1px solid #dfdfdf;

    .file-name {
        width: 100%;

        .clear-file {
            fill: #5b626b;
            margin-left: 10px;
            cursor: pointer;
        }
    }
}

.input-containert {
    display: flex;
    border-radius: 0px 0px 4px 4px;
    gap: 15px;
    align-items: center;
    padding: 0px 20px;
    background-color: #f0f2f5;

    .chat-btn.btn-send {
        margin-top: 5px;
    }
}

.timer {

    font-size: 18px;
    font-weight: 600;

}

.message-body {
    margin: 0 !important;
    padding: 0 !important;
    width: auto;
    height: auto;
}

.send {
    float: right;
    width: auto !important;
    background: #d9fdd3;
    border-radius: 7.5px 7.5px 0 7.5px;
    padding: 4px 10px 7px !important;
    font-size: 12px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    display: inline-block;
    word-wrap: break-word;
}

.message-text {
    margin: 0 !important;
    padding: 5px !important;
    word-wrap: break-word;
    font-weight: 200;
    font-size: 14px;
    padding-bottom: 0 !important;
    direction: rtl;
    text-align: initial;

    pre {
        margin-bottom: 0;
        font-family: 'Tajawal';
    }
}

.message-time {
    margin: 0 !important;
    margin-left: 50px !important;
    font-size: 12px;
    text-align: right;
    color: #9a9a9a;
    padding: 5px;
}

.rtl .message-time.pull-right {
    float: right !important;
}

.received {
    width: auto !important;
    padding: 4px 10px 7px !important;
    border-radius: 7.5px 7.5px 7.5px 0;
    background: #ffffff;
    font-size: 12px;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    word-wrap: break-word;
    display: inline-block;
    max-width: 60%;
}

.message-main-received {
    padding: 3px 12px;
    text-align: initial;
}

.rtl {
    .message-main-received {
        padding: 3px 12px;
        text-align: end;
    }
}

.received:has(audio),
.send:has(audio) {
    background-color: transparent;
    padding: 0 !important;

    .message-text {
        padding: 0 !important;

        audio {
            padding: 0 !important;
            height: 54px;
        }
    }
}

.send {
    .sfeitywo {
        background-color: #d1f4cc;
    }
}

.i5tg98hk {
    background-color: transparent;
    border-left: 0;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-right: 0;
    padding-left: 0;
    padding-right: 0;
    text-align: inherit;
    align-items: stretch;
    display: flex;
    border-bottom: 0;
    border-top: 0;
    outline: none;
    background: none;
    border: 0;
    margin: 0;
}

.sfeitywo {
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
    display: flex;
    background-color: #f5f6f6;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
}

.fhf7t426 {
    display: flex;
    padding-left: 19px;
    padding-right: 19px;
    padding-top: 13px;
    padding-bottom: 13px;
    flex-wrap: nowrap;
    min-width: 0;
    align-items: flex-start;
    flex-direction: row;
}

.spjzgwxb {
    flex-grow: 1;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 0;
    min-height: 0;
    margin-bottom: 0;
    flex-shrink: 1;
    min-width: 0;
    flex-basis: auto;
    order: 0;
}

.m1c2hokz {
    -webkit-line-clamp: 2;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow-x: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow-y: hidden;
}

.e4p1bexh {
    padding-left: 0;
    padding-right: 0;
    padding-top: 3px;
    font-size: 12px;
    height: 18px;
    line-height: 15px;
    padding-bottom: 3px;
    color: #8696a0;
}

.sxl192xd {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA8CAYAAADL94L/AAAByElEQVR4Ae3axdJTQRAFYFyegA3u8ALseCDcicsGhxt3x+G32BXc3X3NBnfXYTqp3sZlhuqpOlXZRL46He9ReJyJxGSTEreaPfEHZiX+1uSJvelVNu+Jvjd7Yk9zI8aSUe0eDpjCIYfNSuw5v/zF5In/6mU27478tXriLJvXjdSwPq1lCDTCmxjiCNav8GZYBVMwWKagX8kWjk9vCcMhYWhEFEw1+oV0wZjdPKY6Vn9EwmBDTYPwBoXCYPLGDQTJjkHQNQRJj0FQtmgs+C8wOHIIkh2DoDu5vD5Xfkz9hsTBWDyxhjDYUDqvLRYSY1JilSQGyyxXOt4QKJPX70NDQmI27gyxHcn9bH/5RFMNAUgoDI4afOAMHBiCdiDNj5woGAhgsCEYudSI1lBCRwoPL957slAoDDYEoPXb/ZVs3FE/y9072fDxsx4BMPVfGOpl1VY/y5++4EWM1Fm9LcCKpy8RpnchDGEIQxjCEIYwhCEMYQhDGMIQhjCEIQxhCEMYwhCGMIQhDGEIQxhYNlXiP+XHXLRDM5thQVpyzIfS2YtLceVEkRmzalsgMArPhp258bA6b/LEb8LqPM930VNdvY/fhMmCxw+Of+4BTcPInBo2AAAAAElFTkSuQmCC);
    background-repeat: no-repeat;
    background-size: contain;
    height: 30px;
    width: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
}

.messages-container:has(.no-messages) {
    position: relative;
    align-items: center;
    display: grid;

    .no-messages {
        text-align: center;

        span {
            background-color: #fff;
            font-size: 16px;
            font-weight: 500;
            padding: 5px 15px;
            border-radius: 5px;
        }
    }
}
</style>